<template>
    <div>
        <div class="modal fade help" id="meeting-form-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="help__title modal-title h3">
                            {{ $translate('ODDeWall::Template.meetingTitle') }}
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="help__content">
                            <p class="help__text" v-html="$translate('ODDeWall::Template.terminModalText')"></p>
                            <form ref="meetingForm" class="help__form mt-5">
                                <div class="row">
                                    <div class="col-12 col-sm-6">
                                        <div class="input-unit" data-validate="text">
                                            <input id="id--meeting-name" type="text" name="name" v-model="name" class="form-control">
                                            <label for="id--meeting-name">
                                                {{ $translate('ODDeWall::Template.terminModalName') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <div class="input-unit" data-validate="select">
                                            <select name="reason" id="id--meeting-reason" v-model="reason" class="form-control">
                                                <option :value="$translate('ODDeWall::Template.terminModalReasonOne')">
                                                    {{ $translate('ODDeWall::Template.terminModalReasonOne') }}
                                                </option>
                                                <option :value="$translate('ODDeWall::Template.terminModalReasonTwo')">
                                                    {{ $translate('ODDeWall::Template.terminModalReasonTwo') }}
                                                </option>
                                                <option :value="$translate('ODDeWall::Template.terminModalReasonThree')">
                                                    {{ $translate('ODDeWall::Template.terminModalReasonThree') }}
                                                </option>
                                            </select>
                                            <label for="id--meeting-reason">
                                                {{ $translate('ODDeWall::Template.terminModalReason') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <div class="input-unit" data-validate="mail">
                                            <input id="id--meeting-email" type="email" name="email" v-model="email" class="form-control">
                                            <label for="id--meeting-email">
                                                {{ $translate('ODDeWall::Template.terminModalMail') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <div class="input-unit" data-validate="text">
                                            <input id="id--meeting-tel" type="tel" name="tel" v-model="tel" class="form-control">
                                            <label for="id--meeting-tel">
                                                {{ $translate('ODDeWall::Template.terminModalTel') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <div class="input-unit" data-validate="text" ref="inputDate">
                                            <el-date-picker class="w-100"
                                                            v-model="date"
                                                            type="date"
                                                            placeholder="tt.mm.yyyy"
                                                            :format="'dd.MM.yyyy'"
                                                            :value-format="'dd.MM.yyyy'"
                                                            :picker-options="pickerOptionsDate"
                                                            :clearable="false"
                                                            @change="removeError('inputDate')">
                                            </el-date-picker>
                                            <label>
                                                {{ $translate('ODDeWall::Template.terminModalDate') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <div class="input-unit" data-validate="text" ref="inputTime">
                                            <el-time-picker class="w-100"
                                                            v-model="time"
                                                            :picker-options="pickerOptionsTime"
                                                            :format="'HH:mm'"
                                                            :value-format="'HH:mm'"
                                                            placeholder="--:--"
                                                            :clearable="false"
                                                            @change="removeError('inputTime')"
                                                            :default-value="defaultTime">
                                            </el-time-picker>
                                            <label>
                                                {{ $translate('ODDeWall::Template.terminModalTime') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="input-unit">
                                            <textarea id="id--meeting-textarea" type="textarea" name="textarea"
                                                      v-model="textarea" class="form-control">
                                            </textarea>
                                            <label for="id--meeting-textarea">
                                                {{ $translate('ODDeWall::Template.terminModalTextarea') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12" v-if="enableConfirmingPrivacyPolicy">
                                        <accept-privacy-policy-check class="mt-2 mb-4"
                                                                     v-model="privacyPolicyAccepted"
                                                                     @input="privacyPolicyValueChanged($event)"
                                                                     :show-error="privacyPolicyShowError">
                                        </accept-privacy-policy-check>
                                    </div>
                                </div>
                                <input class="honey" type="text" name="username" autocomplete="off"
                                       tabindex="-1" v-model="honeypot">
                            </form>
                            <div class="help__btn-wrap">
                                <button class="btn btn-primary" @click="submit">
                                    {{ $translate('ODDeWall::Template.terminModalBtn') }}
                                    <i class="fa" :class="loading ? 'fa-circle-o-notch fa-spin' : ''"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="refRecaptcha" class="recaptcha__wrapper">
            <recaptcha v-if="!!googleRecaptchaApiKey && modalVisible"></recaptcha>
        </div>
    </div>
</template>

<script>
import TranslationService from 'ceres/app/services/TranslationService';
import ValidationService from 'ceres/app/services/ValidationService';
import ApiService from 'ceres/app/services/ApiService';
import NotificationService from 'ceres/app/services/NotificationService';
import {executeReCaptcha} from 'ceres/app/helper/executeReCaptcha';
import {isNullOrUndefined} from 'ceres/app/helper/utils';

import AcceptPrivacyPolicyCheck from "ceres/app/components/customer/AcceptPrivacyPolicyCheck.vue";

export default {

    components: {
        AcceptPrivacyPolicyCheck
    },

    data() {
        return {
            modalVisible: false,
            name: '',
            reason: '',
            email: '',
            tel: '',
            date: '',
            time: '',
            textarea: '',
            honeypot: '',
            privacyPolicyAccepted: false,
            privacyPolicyShowError: false,
            googleRecaptchaApiKey: App.config.global.googleRecaptchaApiKey,
            enableConfirmingPrivacyPolicy: App.config.global.registrationRequirePrivacyPolicyConfirmation,
            loading: false,
            pickerOptionsDate: {
                disabledDate(time) {

                    const today = new Date();

                    today.setHours(0,0,0,0);
                    time.setHours(0,0,0,0);

                    return time.getTime() < today.getTime() || (time.getTime() >= today.getTime() && [0,6].includes(time.getDay()));
                },
                firstDayOfWeek: 1
            },
            timeMin: '',
            timeMax: '',
            timeMaxFriday: ''
        }
    },

    computed: {
        pickerOptionsTime() {

            if(this.getDay(this.date) === 5) {

                this.timeError(this.time);

                return {
                    selectableRange: this.timeMin+':00 - '+this.timeMaxFriday+':00',
                    format: 'HH:mm'
                }
            }

            return {
                selectableRange: this.timeMin+':00 - '+this.timeMax+':00',
                format: 'HH:mm'
            }
        },
        defaultTime() {
            const date = new Date();
            date.setHours(9,0,0,0);
            return date.getTime();
        }
    },

    created() {
        this.timeMin       = this.$translate('ODDeWall::Template.terminModalTimeMin');
        this.timeMax       = this.$translate('ODDeWall::Template.terminModalTimeMax');
        this.timeMaxFriday = this.$translate('ODDeWall::Template.terminModalTimeMaxFriday');
    },

    mounted() {
        this.addEventListener();
    },

    methods: {
        addEventListener() {

            const mobileMenuClose = document.querySelector('.mobile-close-termin');
            if(mobileMenuClose) {
                mobileMenuClose.addEventListener('click', () => {

                    const mobileMenu = document.querySelector('.mobile-navigation');

                    if(mobileMenu && mobileMenu.classList.contains('open')) {
                        mobileMenu.classList.remove('open');
                        document.body.classList.remove('menu-is-visible')
                    }
                })
            }

            this.$refs.inputTime.querySelector('input').addEventListener('change', (e) => {
                this.timeError(e.target.value)
            });
            this.$refs.inputDate.querySelector('input').addEventListener('change', (e) => {
                this.dateError(e.target.value)
            });

            //bs4 uses jquery
            $('#meeting-form-modal').on('shown.bs.modal hidden.bs.modal', () => {
                this.modalVisible = !this.modalVisible;
            })
        },
        getDay(date) {

            if(!isNullOrUndefined(date)) {

                const partials = date.split('.');
                const _date    = new Date(partials[1] + '-' + partials[0] + '-' + partials[2] + ' 12:00:00');

                return _date.getDay();
            }
        },
        submit() {

            this.loading = true;

            executeReCaptcha(this.$refs.refRecaptcha).then((recaptchaToken) => {
                ValidationService.validate(this.$refs.meetingForm).done(() => {

                    if(!this.enableConfirmingPrivacyPolicy || this.privacyPolicyAccepted) {
                        this.send(recaptchaToken);
                    }else {
                        this.showPrivacyError();
                        this.resetRecaptcha();
                        this.loading = false;
                    }
                }).fail(invalidFields => {

                    const invalidFieldNames = this.getInvalidFieldNames(invalidFields);

                    if(invalidFieldNames.length > 0) {
                        NotificationService.error(
                            this.$translate('Ceres::Template.checkoutCheckAddressFormFields', {fields: invalidFieldNames.join(', ')})
                        );
                    }

                    ValidationService.markInvalidFields(invalidFields, 'error');

                    if(this.enableConfirmingPrivacyPolicy && !this.privacyPolicyAccepted) {
                        this.showPrivacyError();
                    }

                    this.resetRecaptcha();
                    this.loading = false;
                });
            });
        },
        send(recaptchaToken) {
            ApiService.post('/rest/dewall/customer/contact/mail', {
                data: {
                    name: this.name,
                    reason: this.reason,
                    email: this.email,
                    tel: this.tel,
                    date: this.date,
                    time: this.time,
                    textarea: this.textarea
                },
                subject: 'Terminanfrage',
                template: 'ODDeWall::Customer.Components.Contact.TerminMail',
                replyTo: this.email,
                recaptchaToken: recaptchaToken,
                userName: this.honeypot
            }).done(() => {

                NotificationService.success(
                    this.$translate('ODDeWall::Template.terminSuccess')
                ).closeAfter(3000);

                this.name = '';
                this.reason = '';
                this.email = '';
                this.tel = '';
                this.date = '';
                this.time = '';
                this.textarea = '';

            }).always(() => {
                this.loading = false;
                this.resetRecaptcha();
            });
        },
        privacyPolicyValueChanged(value) {

            this.privacyPolicyAccepted = value;

            if(value) {
                this.privacyPolicyShowError = false;
            }
        },
        getInvalidFieldNames(invalidFields = []) {

            const fieldNames = [];

            for(const field of invalidFields) {

                let fieldName = field.lastElementChild.innerHTML.trim();

                fieldName = fieldName.slice(-1) === '*' ? fieldName.slice(0, fieldName.length - 1) : fieldName;
                fieldNames.push(fieldName);
            }

            return fieldNames;
        },
        showPrivacyError() {

            this.privacyPolicyShowError = true;

            NotificationService.error(
                this.$translate('Ceres::Template.contactAcceptFormPrivacyPolicy', { hyphen: '&shy;' })
            );
        },
        timeError(time) {

            let max = this.timeMax;

            if(this.getDay(this.date) === 5) {
                max = this.timeMaxFriday;
            }

            if(time > max) {

                NotificationService.warn(
                    TranslationService.translate('ODDeWall::Template.terminModalTimeError')
                ).closeAfter(10000);

                this.time = max;
            }
        },
        dateError(date) {
            if([0,6].includes(this.getDay(date))) {
                NotificationService.warn(
                    TranslationService.translate('ODDeWall::Template.terminModalTimeError')
                ).closeAfter(10000);
            }
        },
        removeError(ref) {
            this.$refs[ref].classList.remove('error');
        },
        resetRecaptcha() {

            if(App.config.global.googleRecaptchaVersion === 2 && window.grecaptcha) {

                const recaptchaId = this.$refs.refRecaptcha.querySelector('[data-recaptcha]');
                window.grecaptcha.reset(recaptchaId);
            }
        }
    }
}
</script>
